import { GridColDef } from "@mui/x-data-grid";
import { TbMail } from "react-icons/tb";

import ClipBoard from "@/components/ClipBoard";
import { TableHeader } from "@/components/TableHeader";
import { User } from "@/types/user.types";

function RenderCell({ value }: { value: string }) {
    return (
        <div className=" font-medium flex items-center h-full pl-2 text-sm   break-all">
            <ClipBoard text={value}>{value}</ClipBoard>
        </div>
    );
}
export const UserEmailColumn = (): GridColDef<User> => {
    return {
        field: "email",
        headerName: "email",
        minWidth: 270,
        flex: 0.6,
        valueGetter: (_value, row) => row.email,
        renderHeader: (params) => <TableHeader Component={TbMail} title={params.colDef.headerName!} />,
        renderCell: ({ value }) => <RenderCell value={value} />,
    };
};
